import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Withdrawal} from "../model/withdrawal";
import {ActivatedRoute} from "@angular/router";
import {AbstractListView} from "../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../shared/actions/session.actions";
import {Page} from '../../shared/view-model/core/page.model';
import {SortInfo} from '../../shared/view-model/core/sort.model';
import {DatatableComponent} from '../../core/visbos-core/ui/components/datatable/datatable.component';

@Component({
  selector: 'vb-withdrawal-log',
  templateUrl: './withdrawal-log.component.html',
  styleUrls: ['./withdrawal-log.component.css']
})
export class WithdrawalLogComponent extends AbstractListView implements OnInit {

  @Input()
  withdrawals: Withdrawal[] = [];

  @ViewChild('timestampTmpl')
  timestampTmpl;

  @ViewChild('table')
  table: DatatableComponent;

  @Input()
  page = new Page();

  @Input()
  sort = new SortInfo();

  @Output()
  pageChange: EventEmitter<Page> = new EventEmitter();

  @Output()
  sortChange: EventEmitter<SortInfo> = new EventEmitter();


  constructor(sessionActions: SessionActions, private route: ActivatedRoute, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.columns = [
      {prop: 'withdrawal_timestamp', name: 'Entnahmezeitpunkt', cellTemplate: this.timestampTmpl, sortable: false},
      {prop: 'consumer.label', name: 'Entnommen von', sortable: false},
      {prop: 'withdrawal_reason_type', name: 'Entnahmegrund', sortable: false},
      {prop: 'withdrawal_reason.label', name: 'Entnahmegrund-Details', sortable: false},
      {prop: 'withdrawal_note', name: 'Bemerkung', sortable: false},
      {prop: 'total_amount', name: 'Anzahl Artikel', sortable: false},
    ];

  }

  onCellUpdate(row: any, res: any) {
    throw new Error("Method not implemented.");
  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal-log/withdrawal-log.component.ts